import { EBAY, ETSY, FAIRE, SHOPIFY } from './channels';
import { ATTRIBUTE } from './attributes';

export const AI_OPERATION = {
  ADD_MAXIMUM: 'add_maximum',
  ENLARGE: 'make_longer',
  FIX: 'fix_spelling_grammar',
  GENERATE: 'generate',
  IMPROVE: 'improve_writing',
  REPLACE: 'replace_all',
  SHORTEN: 'make_shorter',
  TONE: 'change_tone',
  EVENTS: 'promote_event',
};

export const AI_OPERATION_LABEL = {
  [AI_OPERATION.ADD_MAXIMUM]: 'Add maximum',
  [AI_OPERATION.ENLARGE]: 'Make longer',
  [AI_OPERATION.FIX]: 'Fix spelling & grammar',
  [AI_OPERATION.GENERATE]: 'Optimize',
  [AI_OPERATION.IMPROVE]: 'Improve writing',
  [AI_OPERATION.REPLACE]: 'Replace all',
  [AI_OPERATION.SHORTEN]: 'Make shorter',
  [AI_OPERATION.TONE]: 'Change tone',
  [AI_OPERATION.EVENTS]: 'Promote event',
};

export const EVENT = {
  ANNIVERSARY: 'an anniversary',
  BABY_SHOWER: 'a baby shower',
  BACHELOR_PARTY: 'a bachelor party',
  BACHELORETTE_PARTY: 'a bachelorette party',
  BACK_TO_SCHOOL: 'back to school',
  BIRTHDAY: 'a birthday',
  BLACK_FRIDAY: 'Black Friday',
  BRIDAL_SHOWER: 'a bridal shower',
  CHRISTMAS: 'Christmas',
  CYBER_MONDAY: 'Cyber Monday',
  EASTER: 'Easter',
  FATHERS_DAY: 'Father\'s Day',
  GRADUATION: 'a graduation',
  HALLOWEEN: 'Halloween',
  HANUKKAH: 'Hanukkah',
  LGBTQ_PRIDE: 'LGBTQ pride',
  MOTHERS_DAY: 'Mother\'s Day',
  NEW_YEAR: 'New Year\'s',
  THANKSGIVING: 'Thanksgiving',
  VALENTINES_DAY: 'Valentine\'s Day',
  WEDDING: 'a wedding',
};

export const EVENT_OPTIONS = [
  { label: 'Anniversary', value: EVENT.ANNIVERSARY },
  { label: 'Baby shower', value: EVENT.BABY_SHOWER },
  { label: 'Bachelor party', value: EVENT.BACHELOR_PARTY },
  { label: 'Bachelorette party', value: EVENT.BACHELORETTE_PARTY },
  { label: 'Back to school', value: EVENT.BACK_TO_SCHOOL },
  { label: 'Birthday', value: EVENT.BIRTHDAY },
  { label: 'Black Friday', value: EVENT.BLACK_FRIDAY },
  { label: 'Bridal shower', value: EVENT.BRIDAL_SHOWER },
  { label: 'Christmas', value: EVENT.CHRISTMAS },
  { label: 'Cyber Monday', value: EVENT.CYBER_MONDAY },
  { label: 'Easter', value: EVENT.EASTER },
  { label: 'Father\'s Day', value: EVENT.FATHERS_DAY },
  { label: 'Graduation', value: EVENT.GRADUATION },
  { label: 'Halloween', value: EVENT.HALLOWEEN },
  { label: 'Hanukkah', value: EVENT.HANUKKAH },
  { label: 'LGBTQ pride', value: EVENT.LGBTQ_PRIDE },
  { label: 'Mother\'s Day', value: EVENT.MOTHERS_DAY },
  { label: 'New Year\'s', value: EVENT.NEW_YEAR },
  { label: 'Thanksgiving', value: EVENT.THANKSGIVING },
  { label: 'Valentine\'s Day', value: EVENT.VALENTINES_DAY },
  { label: 'Wedding', value: EVENT.WEDDING },
];

export const TONE = {
  CASUAL: 'casual',
  EXCITED: 'excited',
  FRIENDLY: 'friendly',
  HUMOROUS: 'humorous',
  INFORMATIVE: 'informative',
  INSPIRATIONAL: 'inspirational',
  LUXURIOUS: 'luxurious',
  PERSUASIVE: 'persuasive',
  PROFESSIONAL: 'professional',
};

export const TONE_OPTIONS = [
  { label: 'Casual', value: TONE.CASUAL },
  { label: 'Excited', value: TONE.EXCITED },
  { label: 'Friendly', value: TONE.FRIENDLY },
  { label: 'Humorous', value: TONE.HUMOROUS },
  { label: 'Informative', value: TONE.INFORMATIVE },
  { label: 'Inspirational', value: TONE.INSPIRATIONAL },
  { label: 'Luxurious', value: TONE.LUXURIOUS },
  { label: 'Persuasive', value: TONE.PERSUASIVE },
  { label: 'Professional', value: TONE.PROFESSIONAL },
];

export const AI_OPERATIONS = {
  [EBAY]: {
    [ATTRIBUTE.DESCRIPTION]: [
      AI_OPERATION.IMPROVE,
    ],
    [ATTRIBUTE.TITLE]: [
      AI_OPERATION.IMPROVE,
    ],
  },
  [ETSY]: {
    [ATTRIBUTE.DESCRIPTION]: [
      AI_OPERATION.IMPROVE,
    ],
    [ATTRIBUTE.TAGS]: [
      AI_OPERATION.REPLACE,
      AI_OPERATION.ADD_MAXIMUM,
    ],
    [ATTRIBUTE.TITLE]: [
      AI_OPERATION.IMPROVE,
    ],
  },
  [FAIRE]: {
    [ATTRIBUTE.DESCRIPTION]: [
      AI_OPERATION.IMPROVE,
    ],
    [ATTRIBUTE.TITLE]: [
      AI_OPERATION.IMPROVE,
    ],
  },
  [SHOPIFY]: {
    [ATTRIBUTE.DESCRIPTION]: [
      AI_OPERATION.IMPROVE,
    ],
    [ATTRIBUTE.META_DESCRIPTION]: [
      AI_OPERATION.GENERATE,
    ],
    [ATTRIBUTE.PAGE_TITLE]: [
      AI_OPERATION.GENERATE,
    ],
    [ATTRIBUTE.SEO]: [
      AI_OPERATION.GENERATE,
    ],
    [ATTRIBUTE.TITLE]: [
      AI_OPERATION.IMPROVE,
    ],
  },
};

export const OPTIMIZE_OPERATION = {
  [EBAY]: {
    [ATTRIBUTE.DESCRIPTION]: AI_OPERATION.IMPROVE,
    [ATTRIBUTE.TITLE]: AI_OPERATION.IMPROVE,
  },
  [ETSY]: {
    [ATTRIBUTE.DESCRIPTION]: AI_OPERATION.IMPROVE,
    [ATTRIBUTE.TAGS]: AI_OPERATION.REPLACE,
    [ATTRIBUTE.TITLE]: AI_OPERATION.IMPROVE,
  },
  [FAIRE]: {
    [ATTRIBUTE.DESCRIPTION]: AI_OPERATION.IMPROVE,
    [ATTRIBUTE.TITLE]: AI_OPERATION.IMPROVE,
  },
  [SHOPIFY]: {
    [ATTRIBUTE.DESCRIPTION]: AI_OPERATION.IMPROVE,
    [ATTRIBUTE.META_DESCRIPTION]: AI_OPERATION.GENERATE,
    [ATTRIBUTE.PAGE_TITLE]: AI_OPERATION.GENERATE,
    [ATTRIBUTE.TITLE]: AI_OPERATION.IMPROVE,
  },
};

export const ATTRIBUTE_TO_DESTINATION = {
  [ATTRIBUTE.META_DESCRIPTION]: 'seo_description',
  [ATTRIBUTE.PAGE_TITLE]: 'seo_title',
};

export const DESTINATION_TO_ATTRIBUTE = {
  seo_description: ATTRIBUTE.META_DESCRIPTION,
  seo_title: ATTRIBUTE.PAGE_TITLE,
};
